import { makeAutoObservable, observable } from "mobx";
export class LogStore {
    STORAGE_KEY = "adminConsoleLog";
    // All errors that happened during app that we want to show to user
    errors = observable.array([]);
    lastError = null;
    lastSuccess = null;
    lastErrorTimeoutId = null;
    lastSuccessTimeoutId = null;
    showErrorTimeout = 5_000;
    showSuccessTimeout = 5_000;
    constructor() {
        makeAutoObservable(this, {
            logResponseError: true,
            logError: true,
            logSuccess: true,
            clearErrors: true,
        });
        this.errors = this.loadErrors();
    }
    logResponseError(response, appMessage) {
        // response has at least one error defined
        if (response.apiError || response.error) {
            this.logError({
                appMessage: appMessage,
                apiError: response.apiError,
                error: response.error,
            });
        }
    }
    logError(err) {
        const withTimestamp = {
            timestamp: Date.now(),
            ...err,
        };
        this.errors.unshift(withTimestamp); // put the item at the start for chronological rendering
        this.lastError = withTimestamp;
        this.saveErrors(this.errors);
        this.startErrorDismissTimer();
    }
    logSuccess(message, localizedKey) {
        this.lastSuccess = { message, localizedKey };
        this.startSuccessDismissTimer();
    }
    clearErrors() {
        this.errors = observable.array([]);
        this.lastError = null;
        this.saveErrors(this.errors);
    }
    startErrorDismissTimer() {
        if (this.lastErrorTimeoutId) {
            clearTimeout(this.lastErrorTimeoutId);
        }
        this.lastErrorTimeoutId = setTimeout(() => {
            this.lastError = null;
            this.lastErrorTimeoutId = null;
        }, this.showErrorTimeout);
    }
    startSuccessDismissTimer() {
        if (this.lastSuccessTimeoutId) {
            clearTimeout(this.lastSuccessTimeoutId);
        }
        this.lastSuccessTimeoutId = setTimeout(() => {
            this.lastSuccess = null;
        }, this.showSuccessTimeout);
    }
    loadErrors() {
        try {
            const storedErrors = localStorage.getItem(this.STORAGE_KEY);
            return storedErrors ? JSON.parse(storedErrors) : [];
        }
        catch {
            return [];
        }
    }
    saveErrors(errors) {
        try {
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(errors));
        }
        catch (error) {
            console.error("Failed to save errors to localStorage", error);
        }
    }
}
